import {
  ModalBody,
  ModalFooter,
  ModalProps
} from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import Modal from "components/Modal/Modal";
import React from "react";
import { ApplyButton } from "../ApplyButton/ApplyButton";
import * as styles from "./ModalAutocomplete.module.scss";
import { Autocomplete } from "../Autocomplete/Autocomplete";
import { Trans, useLingui } from "@lingui/react/macro";
import { PublicFacetSource } from "components/FindYourCruise/Components/Autocomplete/buildSources";

export type ModalAutocompleteProps = {
  isVisible?: boolean;
  indexName: string;
  autocompleteEnabledSources?: PublicFacetSource[];
};

type Props = ModalAutocompleteProps &
  Omit<ModalProps, "modal"> & {
    modal: Omit<ModalProps["modal"], "isOpen">;
  };

const ModalAutocomplete: React.FC<Props> = ({
  modal,
  dataContentName,
  autocompleteEnabledSources,
  isVisible = false,
  indexName,
  title
}) => {
  const { t } = useLingui();
  return (
    <Modal
      title={title}
      modal={{
        ...modal,
        isOpen: true, // force modal to be always mounted. If unmounted the filters are resetted
        portalClassName: clsx({ [styles.hideModal]: !isVisible })
      }}
      size="fullscreen"
      dataContentName={dataContentName}
      labels={{ close: <Trans>Apply filters</Trans> }}
    >
      <ModalBody variant="wide" removeScroll={isVisible}>
        <Autocomplete
          placeholder={t`Where to go (destination, country, city)?`}
          openOnFocus={true}
          indexName={indexName}
          dataContentName="where_to_go"
          detachedMode
          enabledSources={autocompleteEnabledSources}
        />
      </ModalBody>
      <ModalFooter className={styles.footer}>
        <ApplyButton onClick={modal.onRequestClose} />
      </ModalFooter>
    </Modal>
  );
};

export default ModalAutocomplete;
